import { GlButton } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import PipelinesEmptyState from './pipelines_empty_state.vue?vue3';
export default {
    name: 'ExternalConfigEmptyState',
    components: {
        GlButton,
        PipelinesEmptyState
    },
    i18n: {
        title: s__("ExternalConfigEmptyState|This project's pipeline configuration is located outside this repository"),
        description: s__("ExternalConfigEmptyState|To view or edit the pipeline configuration, check your project's CI/CD settings for the external file location, then navigate to that project or repository.")
    },
    props: {
        newPipelinePath: {
            type: String,
            required: false,
            default: ''
        }
    }
};
